import { render, staticRenderFns } from "./possword.vue?vue&type=template&id=3d27453a&scoped=true"
import script from "./possword.vue?vue&type=script&lang=js"
export * from "./possword.vue?vue&type=script&lang=js"
import style0 from "./possword.vue?vue&type=style&index=0&id=3d27453a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d27453a",
  null
  
)

export default component.exports